import { Box, styled, Button, css } from '@mui/material';

export const SuccessStepContainer = styled(Box)`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const PageSubtitleBox = styled(Box)`
  max-width: 370px;
  margin: 0 auto;

  ${({ theme }) => css`
    ${theme.breakpoints.down('sm')} {
      max-width: unset;
    }
  `}
`;

export const BackButton = styled(Button)`
  padding-left: 88px;
  padding-right: 88px;
  margin-top: 80px;
`;

export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
